import React from 'react';
import BusinessRulesMap from '@/components/admin/BusinessRulesMap';

const AdminBusinessTests = () => {

  return <BusinessRulesMap />;
};

export default AdminBusinessTests;
